import React, { useState, useEffect } from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import EmployeesArea from "../../../components/EmployeesArea/EmployeesArea";
import API from '../../../api/api';
import { getImageUrl } from '../../../utils/imageUtils';
import { GARAGE_ABOUT_HTML } from '../../../content/garageAboutHtml';

const garageApi = new API();

export default function EmployeesSection(props) {
  const [employees, setEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [snackBar, setSnackBar] = useState(false);

  useEffect(() => {
    garageApi.openEndpoints.employees.getAll()
      .then((employeesGET) => {
        try {
          let employeesData = [];
          if (employeesGET && employeesGET.data) {
            if (Array.isArray(employeesGET.data)) {
              employeesData = employeesGET.data;
            } else if (employeesGET.data.results && Array.isArray(employeesGET.data.results)) {
              employeesData = employeesGET.data.results;
            }
          }
          setEmployees(employeesData);
          setLoadingEmployees(true);
        }
        catch (e) {
          setEmployees([]);
          setSnackBar(true);
          setLoadingEmployees(true);
        }
      })
      .catch(() => {
        setEmployees([]);
        setLoadingEmployees(true);
      });
  }, []);

  function closeSnackBar(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBar(false);
  }

  return (
    <>
      <Snackbar open={snackBar} autoHideDuration={6000} onClose={closeSnackBar}>
        <MuiAlert elevation={6} variant="filled" onClose={closeSnackBar} severity="warning">
          Server Fehler 500
        </MuiAlert>
      </Snackbar>

      <section className="spg-section spg-team-about">
        <div className="spg-kicker">Garage</div>
        <h2 className="spg-title">Über uns</h2>
        <div
          className="spg-lead spg-about-copy"
          dangerouslySetInnerHTML={{
            __html: props.garageAboutText && String(props.garageAboutText).trim()
              ? props.garageAboutText
              : GARAGE_ABOUT_HTML,
          }}
        />
      </section>

      <section className="spg-section spg-team-people">
        <div className="spg-kicker">Team</div>
        <h2 className="spg-title">Mitarbeiter</h2>
        <p className="spg-lead">Die Gesichter hinter Service, Diagnose und Reparatur.</p>

        <div className="spg-people">
          {loadingEmployees ? (
            Array.isArray(employees) && employees.length > 0 ? employees.map((employee, index) => (
              <EmployeesArea
                key={employee.unikey || index}
                image={employee.image ? getImageUrl(employee.image, 'large') || getImageUrl(employee.image, 'original') || '' : ''}
                name={employee.name || ''}
                position={employee.position || ''}
                job={employee.job || ''}
                email={employee.email || ''}
                phone={employee.phone || ''}
                description={employee.description || ''}
              />
            )) : (
              <p className="spg-lead">Noch keine Mitarbeiter vorhanden.</p>
            )
          ) : (
            Array.from({ length: 3 }, (_, i) => (
              <article key={i} className="spg-person is-loading">
                <div className="spg-person-photo is-empty" />
                <div className="spg-person-body">
                  <span className="spg-person-role"> </span>
                  <div className="spg-service-skel" />
                  <div className="spg-service-skel is-wide" />
                </div>
              </article>
            ))
          )}
        </div>
      </section>
    </>
  );
}
